<div class="people-listing-container">
  <div class="report-header">
    <h1 class="report-title">Users ({{ statusUsersCount() }})</h1>
  </div>

  <div class="search-filter-container">
    <ul class="search_left_wrap">
      @if (isManagerUser()) {
      <li class="add_btn_wrap">
        <button mat-raised-button color="primary" (click)="openAddPeopleSliderWithoutParent()" class="add-btn">
          <i class="wl_icon_add"></i>
          Add New
          <i class="arrow wl_icon_drop-fill"></i>
        </button>
      </li>
      }

      <li class="export_btn_wrap">
        <a (click)="hasData() ? openExportModal() : ''" [class.disabled]="!hasData()"
          [matTooltip]="!hasData() ? 'No people available to export.' : ''" matTooltipPosition="below"
          matTooltipClass="export-tooltip">
          <label>Export</label>
          <i class="wl_icon_xls"></i>
        </a>
      </li>

      <!-- Action Buttons — Manager only -->
     @if (isManagerUser() && hasSelectedPeople()) {
      <li class="edit_btn_wrap">
        @if (hasSingleSelectedPeople()) {
        <button (click)="openEditPeopleSlider()" class="edit-btn">
          <i class="wl_icon_edit_btn"></i>
          Edit
        </button>
        }
        <!-- <button
          *ngIf="hasMultipleSelectedPeople()"
          (click)="openEditMultiplePeopleForm()"
          class="edit-btn"
        >
          <i class="wl_icon_edit_btn"></i>
          Edit Multiple
        </button> -->
        <!-- Dynamic Status Toggle Buttons -->
         @if (hasSelectedActivePeople()) {
        <button (click)="openDeactivatePeoplePopup()" class="deactivate_btn"
          [disabled]="deactivateLoading()">
          @if (deactivateLoading()) {
          <app-spinner [size]="16"></app-spinner>
          } @else {
          <i class="wl_icon_deactivate"></i>
          <span>Deactivate</span>
          }
        </button>
      }
        @if (hasSelectedInactivePeople()) {
        <button (click)="openActivatePeoplePopup()" class="activate_btn">
          <i class="wl_icon_activate"></i>
          Activate
        </button>
        }

        <button (click)="openDeletePeoplePopup()" class="dlt_btn" [disabled]="deleteLoading()">
          @if (deleteLoading()) {
          <app-spinner [size]="16"></app-spinner>
          } @else {
          <i class="wl_icon_delete"></i>
          <span>Delete</span>
          }
        </button>
        <!-- <button class="share_btn" (click)="showConfirmSharePeoplePopup()" disabled>
          <i class="wl_icon_share-btn"></i>
          Share
        </button> -->
      </li>
    }
    </ul>

    <ul class="search_right_wrap">
      <!-- Status Filter Toggle -->
      <li class="status-filter-wrap">
        <div class="status-toggle-container">
          <!-- <label class="status-toggle-label">Show:</label> -->
          <div class="status-toggle-slider">
            <label class="toggle-switch">
              <input
                type="checkbox"
                [checked]="statusFilter() === 'active'"
                (change)="onStatusToggleChange($event)"
              />
              <span class="slider">
                <span class="slider-knob"></span>
              </span>
            </label>
            <span class="toggle-label" (click)="toggleStatusFilter()">
              {{ statusFilter() === 'active' ? 'Active' : 'Inactive' }}
            </span>
          </div>
        </div>
      </li>

      <li class="search-box">
        <input type="text" class="search-field" [ngModel]="searchText()" (ngModelChange)="searchText.set($event)"
          (input)="onSearchInput()" (keyup.enter)="onSearch()"
          placeholder="Search by Name, Email, Phone, Address, or Timezone" />
        <i class="wl_icon_Search" (click)="onSearch()"></i>
        @if (searchText()) {
        <i class="fas fa-times clear-search" (click)="clearSearch()" title="Clear search"></i>
        }
      </li>
    </ul>
  </div>

  <!-- Loading State -->
  @if (isPageLoading()) {
  <div class="project-loader-overlay">
    <div class="loader-container">
      <app-spinner [size]="40"></app-spinner>
    </div>
  </div>
  }

  <!-- Error State -->
  @if (error() && !isPageLoading()) {
  <div class="project-error-overlay">
    <div class="error-container">
      <div class="error-icon">
        <mat-icon>error_outline</mat-icon>
      </div>
      <div class="error-content">
        <h3>Failed to Load Project</h3>
        <p>Something went wrong. Please try again later.</p>
        <div class="error-actions">
          <button class="btn-save" (click)="retryLoading()">
            Try Again
          </button>
          <button class="btn-cancel" (click)="goBack()">
            Go Back
          </button>
        </div>
      </div>
    </div>
  </div>
  }

  <!-- Data Table -->
  @if (!isPageLoading() && !error()) {
  <div class="table-container" [class.table-container--top-scroll-visible]="tableHScroll.showTopScrollbar()">
    <div
      class="table_scroll_top"
      #peopleListingTableTopScroll
      [class.table_scroll_top--hidden]="!tableHScroll.showTopScrollbar()"
    >
      <div class="table_scroll_top_inner" [style.width.px]="tableHScroll.topScrollbarWidth()"></div>
    </div>
    <div class="table_scroll_wrap" #peopleListingTableBottomScroll>
      <table mat-table [dataSource]="paginatedDataSource" matSort (matSortChange)="sortData($event)"
        class="mat-elevation-z1 people_table">
        <!-- Select Checkbox Column (shown only for Manager via getDisplayedColumns) -->
        <ng-container matColumnDef="select">
          <th mat-header-cell *matHeaderCellDef class="col_select">
            <div class="checkbx_group">
              <label class="check_label">
                <input type="checkbox" id="master-checkbox" name="master-checkbox" [checked]="isAllSelected()"
                  (change)="toggleAllSelection($event)" [indeterminate]="isIndeterminate()"
                  class="custom-checkbox master-checkbox" />
              </label>
            </div>
          </th>
          <td mat-cell *matCellDef="let person" class="col_select">
            <div class="checkbx_group">
              <label class="check_label">
                <input type="checkbox" [id]="'row-checkbox-' + person._id" [name]="'row-checkbox-' + person._id"
                  [checked]="isPersonSelected(person._id)" (change)="togglePersonSelection(person._id, $event)"
                  class="custom-checkbox row-checkbox" />
              </label>
            </div>
          </td>
        </ng-container>

        <!-- Dynamic Columns -->
        @for (header of tableHeaders(); track header.prop) {
        <ng-container [matColumnDef]="header.prop">
          <th mat-header-cell *matHeaderCellDef mat-sort-header [class]="'col-' + header.prop"
            [class.col-last-login]="isLastLoggedInColumn(header.prop, header.fieldName)"
            [class.col-login]="isLoginColumn(header.prop, header.fieldName)">
            {{ header.fieldName }}
          </th>
          <td mat-cell *matCellDef="let person" [class]="'col-' + header.prop"
            [class.col-last-login]="isLastLoggedInColumn(header.prop, header.fieldName)"
            [class.col-login]="isLoginColumn(header.prop, header.fieldName)">
            <div class="cell-content">
              <!-- Special handling for different field types -->
              @switch (header.prop) {
              @case ('name') {
              <div class="person-info">
                <div
                  class="person-avatar"
                  [ngClass]="getStatusClass((person.isOnline ?? false) ? 'online' : 'offline')"
                >
                  @if (person.image && person.image.trim() !== '') {
                  <img [src]="person.image" [alt]="person.name + ' avatar'" class="avatar-image"
                    (error)="onImageError($event)" />
                  <div class="avatar-placeholder" [style.background-color]="getAvatarColor(person._id)"
                    style="display: none;">
                    {{ getInitials(person.name) }}
                  </div>
                  } @else {
                  <div class="avatar-placeholder" [style.background-color]="getAvatarColor(person._id)">
                    {{ getInitials(person.name) }}
                  </div>
                  }
                </div>
                <div class="person-details">
                  <a class="person-name-link"
                    [href]="personViewHref(person._id)"
                    target="_blank"
                    rel="noopener noreferrer"
                    matTooltip="View person details" matTooltipPosition="below" matTooltipClass="person-name-tooltip">
                    {{ person.name }}
                    <!-- <mat-icon class="link-icon">open_in_new</mat-icon> -->
                  </a>
                  <div class="person-status-indicator">
                    <!-- <span class="status-dot" [ngClass]="getStatusClass(person.isActive ? 'active' : 'inactive')"></span> -->
                    <span class="status-text">{{ person.isOnline ? 'Online' : 'Offline' }}</span>
                  </div>
                </div>
              </div>
              }

              @case ('email') {
              <a [href]="'mailto:' + person.email" class="email-link people-email-cell"
              [appCopyableTruncateTooltip]="addressTooltipSource(person, header.prop)">
                {{ person.email }}
              </a>
              }

              @case ('phone') {
              <a [href]="'tel:' + person.phone" class="phone-link">
                {{ person.phone || 'N/A' }}
              </a>
              }

              @case ('status') {
              <span class="status-badge" [ngClass]="getStatusClass(person.isActive ? 'active' : 'inactive')">
                {{ person.isActive ? 'Active' : 'Inactive' }}
              </span>
              }

              @case ('accesslevel') {
              <span class="access-level">
                {{ getAccessLevelDisplayName(person) }}
              </span>
              }

              @case ('address') {
              <span
                class="people-address-cell"
                [appCopyableTruncateTooltip]="addressTooltipSource(person, header.prop)">
                {{ getFieldValue(person, header.prop) || 'N/A' }}
              </span>
              }

              @default {
              @if (isLoginColumn(header.prop, header.fieldName)) {
              <button
                type="button"
                class="login-as-btn"
                (click)="loginAsUser(person, $event)"
                [disabled]="loginAsLoadingId() === person._id"
                matTooltipAlways
                [matTooltip]="'Login as ' + person.name"
                matTooltipPosition="above"
                matTooltipClass="login-as-tooltip"
                [attr.aria-label]="'Login as ' + person.name"
              >
                @if (loginAsLoadingId() === person._id) {
                <app-spinner [size]="16"></app-spinner>
                } @else {
                <mat-icon>login</mat-icon>
                }
              </button>
              } @else {
              {{ getFieldValue(person, header.prop ,header.fieldName)  || 'N/A' }}
              }
              }
              }
            </div>
          </td>
        </ng-container>
        }

        <tr mat-header-row *matHeaderRowDef="getDisplayedColumns()"></tr>
        <tr mat-row *matRowDef="let person; columns: getDisplayedColumns();" class="people-row"
          [class.selected]="isPersonSelected(person._id)"></tr>
      </table>
    </div>

    <!-- Pagination -->
    @if (dataSource.length > pageSize()) {
    <app-custom-paginator [totalItems]="dataSource.length" [pageSize]="pageSize()" [currentPage]="currentPage()"
      [pageSizeOptions]="pageSizeOptions" [showPageSelect]="false" [itemLabel]="'People'"
      (pageChange)="onPageChange($event)" (pageSizeChange)="onPageSizeChange($event)"></app-custom-paginator>
    }

    <!-- Empty State -->
    @if (paginatedDataSource.length === 0 && !isPageLoading()) {
    <div class="empty-state">
      <div class="empty-icon"><i class="wl_icon_people"></i></div>
      @if (searchTerm()) {
      <h3>No People Found</h3>
      <p>No people match your search criteria "<strong>{{ searchTerm() }}</strong>". Try adjusting your search terms or
        filters.</p>
      <button class="clear-search-btn" (click)="clearSearch()">
        Clear Search
      </button>
      } @else {
      <h3>No {{ statusFilter() === 'active' ? 'Active' : 'Inactive' }} People</h3>
      <p>No {{ statusFilter() === 'active' ? 'active' : 'inactive' }} people found. Try changing the status filter or
        add new people.</p>
      <button class="clear-search-btn" (click)="setStatusFilter(statusFilter() === 'active' ? 'inactive' : 'active')">
        Show {{ statusFilter() === 'active' ? 'Inactive' : 'Active' }} People
      </button>
      }
    </div>
    }
  </div>
  }

  <!-- Add People Slider -->
  @if (showAddPeopleSlider()) {
  <div class="add-people-slider">
    <div class="slider-backdrop"></div>
    <div class="slider-panel">
      <button class="close-btn" (click)="closeAddPeopleSlider()" title="Close">
        <mat-icon>close</mat-icon>
      </button>
      <app-add-people-form (personSubmitted)="handlePersonSubmitted($event)"
        (close)="closeAddPeopleSlider()"></app-add-people-form>
    </div>
  </div>
  }

  <!-- Edit People Slider -->
  @if (showEditPeopleSlider()) {
  <div class="add-people-slider">
    <div class="slider-backdrop"></div>
    <div class="slider-panel">
      <button class="close-btn" (click)="closeEditPeopleSlider()" title="Close">
        <mat-icon>close</mat-icon>
      </button>
      <app-edit-people-form [person]="selectedPersonForEdit()" (personUpdated)="handlePersonUpdated($event)"
        (close)="closeEditPeopleSlider()"></app-edit-people-form>
    </div>
  </div>
  }

  <!-- Export Modal -->
  <app-confirm-export [show]="showExportModal()" [exportType]="'people'" (confirm)="onExportConfirm($event)"
    (cancel)="closeExportModal()" (closed)="closeExportModal()"
    (showChange)="showExportModal.set($event)"></app-confirm-export>

  <!-- Delete Confirmation Popup -->
  <app-confirm-popup [show]="showDeleteConfirmPopup()" [title]="'Delete People'"
    [message]="'Are you sure you want to delete ' + selectedPeople().length + ' selected people? This action cannot be undone.'"
    [confirmText]="'Delete'" [cancelText]="'Cancel'" [type]="'delete'" [showCancel]="true" [loading]="deleteLoading()"
    (confirm)="onDeleteConfirm()" (cancel)="onDeleteCancel()" (closed)="closeDeleteConfirmPopup()"></app-confirm-popup>

  <!-- Deactivate Confirmation Popup -->
  <app-confirm-popup [show]="showDeactivateConfirmPopup()" [title]="'Deactivate People'"
    [message]="'Are you sure you want to deactivate ' + selectedPeople().length + ' selected people? They will no longer be able to access the system.'"
    [confirmText]="'Deactivate'" [cancelText]="'Cancel'" [type]="'warning'" [showCancel]="true"
    [loading]="deactivateLoading()" (confirm)="onDeactivateConfirm()" (cancel)="onDeactivateCancel()"
    (closed)="closeDeactivateConfirmPopup()"></app-confirm-popup>

  <!-- Activate Confirmation Popup -->
  <app-confirm-popup [show]="showActivateConfirmPopup()" [title]="'Activate People'"
    [message]="'Are you sure you want to activate ' + selectedPeople().length + ' selected people? They will be able to access the system again.'"
    [confirmText]="'Activate'" [cancelText]="'Cancel'" [type]="'success'" [showCancel]="true"
    (confirm)="onActivateConfirm()" (cancel)="onActivateCancel()"
    (closed)="closeActivateConfirmPopup()"></app-confirm-popup>
</div>